<div >
    <mat-progress-bar mode="determinate" value="{{completeProgress}}"></mat-progress-bar>
    Processing ({{currentProcessIndex + 1}} of {{totalProcessCount}}) - {{proccessingFileName}}

</div>
<div [hidden]="hideOverwrite">
    <h3>{{proccessingFileName}} Already Exists</h3>
    <button mat-raised-button (click)="cancelProcess()">Cancel</button>&nbsp;&nbsp;
    <button mat-raised-button color="accent"  (click)="skipFile()">Skip</button>&nbsp;&nbsp;
    <button mat-raised-button color="accent"  (click)="overwriteFile()">Replace</button>&nbsp;&nbsp;
    <button mat-raised-button color="primary" (click)="overwriteAll()">Replace All</button> &nbsp;&nbsp;
</div>
